import {PulseLoader} from 'react-spinners';

export const Loading = () => {
  return <PulseLoader color={'#3DB0FB'} loading={true} size={10} margin={2} />;
};
